import { Component } from '@angular/core';
import { CoreSignalProfileMatchEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Profile Matches') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignalprofilematch-form',
    templateUrl: './coresignalprofilematch.form.component.html'
})
export class CoreSignalProfileMatchFormComponent extends BaseFormComponent {
    public record!: CoreSignalProfileMatchEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

